import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutation'
import actions from './actions'
import getters from './getters'
import diag from './modules/diag'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    diag
  },
  plugins: [createPersistedState({
    storage: window.localStorage,
    supportCircular: true,
    reducer (val) {
      return {
        corpId: val.corpId,
        userInfo: val.userInfo,
        jobsiteID: val.jobsiteID,
        preJobsiteID: val.preJobsiteID,
        menuShow: val.menuShow,
        projectList: val.projectList,
        CreatorId: val.CreatorId,
        plan: val.plan,
        planCondition: val.planCondition,
        jobsiteName: val.jobsiteName,
        jobsiteLocation: val.jobsiteLocation,
        showManagement: val.showManagement,
        mockUserInfo: val.mockUserInfo,
        measureUnitType: val.measureUnitType,
        temperatureUnit: val.temperatureUnit,
        M2Integration: val.M2Integration,
        corpName: val.corpName,
        hasCloudGroup: val.hasCloudGroup,
        planTabType: val.planTabType,
        corporationCondition: val.corporationCondition,
        projectCondition: val.projectCondition,
        corporationConditionOrderby: val.corporationConditionOrderby,
        planConditionOrderby: val.planConditionOrderby,
        taskConditionOrderby: val.taskConditionOrderby,
        reportConditionOrderby: val.reportConditionOrderby,
        productConditionOrderby: val.productConditionOrderby,
        photoConditionOrderby: val.photoConditionOrderby,
        documentsConditionOrderby: val.documentsConditionOrderby
      }
    }
  })
  ]
})
